var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"loading",class:[{ small: _vm.small }]},[_c('img',{staticClass:"loading-img",attrs:{"src":require("./logo.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }